// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3bNuc","upload":"Small_upload__1_sxT","imageWrap":"Small_imageWrap__2hTGy","removeBtn":"Small_removeBtn__1GBbU"};